export type State = {
  temp: 'temp';
};

const initialState: State = {
  temp: 'temp'
};

const Application = (state: State = initialState, action: any) => {
  switch (
    action.type
    // temp
  ) {
  }
  return state;
};

export default Application;



// WEBPACK FOOTER //
// ./src/reducers/Application.ts